// must be number key
const SECRET_KEY = 987654321;  

// ----------------------
// SHORT ENCRYPT (URL SAFE)
// ----------------------
export function encryptUrl(text) {
  const xorResult = [];

  console.log("texttext",text)

  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i) ^ (SECRET_KEY % 256);
    xorResult.push(charCode);
  }

  // convert to short Base62
  let base62 = btoa(String.fromCharCode(...xorResult))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

      console.log("base62",base62)

  return base62;
}

// ----------------------
// SHORT DECRYPT
// ----------------------
export function decryptUrl(encoded) {
  const base64 = encoded
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(encoded.length + (4 - (encoded.length % 4)) % 4, "=");

  const buffer = atob(base64);
  let result = "";

  for (let i = 0; i < buffer.length; i++) {
    const decodedChar = buffer.charCodeAt(i) ^ (SECRET_KEY % 256);
    result += String.fromCharCode(decodedChar);
  }

  return result;
}
